<template>
  <div class="autorization-reject-container">
    <TextArea title="Motivo da Reprovação" field="reason" :formName="formName" :required="true" :maxLength="500"
      placeholder="Descreva o motivo da reprovação" v-model="reason" />
  </div>
</template>

<script>
import TextArea from "@/ui/forms/TextArea";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "AutorizationReject",
  components: { TextArea },
  data() {
    return {
      formName: "autorizationRejectForm",
      reason: "",
    };
  },
  computed: {
    ...mapGetters("validation", ["isFormValid"]),
    formValid() {
      return this.isFormValid(this.formName);
    },
  },
  watch: {
    reason: {
      handler(value) {
        this.$emit("input", { reason: value });
      },
      immediate: true,
    },
    formValid: {
      handler(value) {
        this.$emit("valid", value);
      },
      immediate: true,
    },
  },
  mounted() {
    this.resetValidation(this.formName);
  },
  methods: {
    ...mapMutations("validation", ["resetValidation"]),
  },
};
</script>

<style scoped>
.autorization-reject-container {
  padding: 4px 0;
}
</style>
